(() => {
    /* Helps displaying all active filters and brands */
    class Search extends App.Component {
        constructor(container) {
            super(container);
            /* Containers */
            this.input = this.container.querySelector('input[name="search"]');
            App.Interface.Search.Observer.register(this);
            this
                .build()
                .update()
                .bind()
            ;
        }

        /* Constants */
        get Interface() { return this._interface || App.Interface.Search }
        get data() { return this.Interface.get }

        /* Getters */
        get brandName() {
            // todo: retrieve full name from "brands" api when available
            return this.data.brand;
        }

        /* Setters */
        set query(query) {
            this.input.value = query;
        }

        setInterface(Interface) {
            this.Interface.Observer.remove(this);
            this._interface = Interface;
            this.Interface.Observer.register(this);
            return this;
        }

        bind() {
            /* Change search with input field */
            let search;
            $(this.input)
                .keyup(event => {
                    search = setTimeout(() => {
                        // Change query only of query is different
                        if (this.Interface.query !== event.target.value)
                            this.Interface.setQuery(event.target.value);
                    }, 250);
                })
                .keydown(event => {
                    if(event.keyCode == 13) {
                        event.preventDefault();
                        return false;
                    }
                    clearTimeout(search);
                })
            ;
            /* Reset filter */
            $(document).on('click', '.js-reset', e => this.Interface.removeBrand().Filter.reset());
            // Do not allow any action on form submit
            this.$.on('submit', 'form', e => e.preventDefault());

            return this;
        }

        build() {
            this.query = this.Interface.query;
            return this;
        }

        /**
         * Update component when hooks change
         * @return {Search}
         */
        update() {
            this.Interface.Filter.selected.length || this.Interface.brand ?
                document.body.classList.add('has-filter') : document.body.classList.remove('has-filter');
            return this;
        }
    }
    App.Components.register('.overview-search', Search);
})();
